import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  deleteCartId,
  getCart,
  getOrderHistory,
  increaseDecrease,
} from "../Services/Service";
import UserContext from "../context/UserContext";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLogin from "./bottomLogin";

const initialValue = {
  discountedTotal: "",
  cartTotal: "",
  totalProducts: "",
  totalQuantity: "",
  userId: "",
  id: "",
};
const initialCart = {
  showCart: "N",
};
// const isLoggedIn = localStorage.getItem('token')
// console.log("bbbbbbbbbbb",isLoggedIn)
const OrderDetails = () => {
  const nav = useNavigate();
  const location = useLocation();
  const [cartData, setCartData] = useState([]);
  const [issOpen, setsOpen] = useState();
  const [showCartData, setShowCartData] = useState("Y");
  const [price, setPrice] = useState(initialValue);
  const [time, setTime] = useState(false);
  const { state, update } = useContext(UserContext);
  // console.log(location.state)
  useEffect(() => {
    let loggedInStatus = localStorage.getItem("auth")
      ? localStorage.getItem("auth")
      : 0;
    if (loggedInStatus === 0) {
      //   setsOpen(true);
      // return nav('/login',{state:location.pathname})
    } else {
      fetchOrderHistoryList();
    }
  }, []);

  const fetchOrderHistoryList = async () => {
    getOrderHistory()
      .then((res) => {
        if (res.data.status === 1) {
          setShowCartData("Y");
        } else {
          setShowCartData("N");
        }
        return res.data.data;
      })
      .then((res) => {
        const arr = res.map((data) => {
          return { ...data, show: false };
        });
        setCartData(arr);
      });
  };

  const handleClick = (e) => {
    // set
    const arr = cartData;
    arr[e.target.id].show = !arr[e.target.id].show;
    // console.log(arr)
    setCartData([...arr]);
  };

  return (
    <div className="content-apps mt-5" style={{ paddingBottom: "60px" }}>
      {/* <div className="circleblur3"/> */}
      <HelmetProvider>
        <Helmet>
          <title>Orders</title>
        </Helmet>
      </HelmetProvider>
      <div className="container">
        <div className="OrderDetails__allOrderHisHeader">
          <div className="OrderDetails__orderHolder">
            <div className="OrderDetails__labelHeader">Order placed on:</div>
            <div className="OrderDetails__orderHolderTxt">20 Mar 2023</div>
          </div>
          <div className="OrderDetails__orderHolder">
            <div className="OrderDetails__labelHeader">Order ID:</div>
            <div className="OrderDetails__orderHolderTxt">125588562</div>
          </div>
          <div className="OrderDetails__orderHolder">
            <div className="OrderDetails__labelHeader">Order Total:</div>
            <div className="OrderDetails__orderHolderTxt">₹ 2001</div>
          </div>
        </div>
        <div>
          <div
            className="OrderDetails__base"
            style={{ justifyContent: "space-between" }}
          >
            <div className="OrderDetails__order">
              <div className="OrderMetaHolder__header">Item Details</div>
              {/* <hr style={{marginTop: 0,color:"white"}}/> */}
              <div className="rowGap10" />
              <div className="rowGap10" />
              <div>
                <div className="OrderMetaHolder__base">
                  <div style={{ width: "100%", display: "flex" }}>
                    <div className="OrderMetaHolder__productImageHolder">
                      <div className="ProductImage__base">
                        <div className="ProductImage__imageHolder">
                          <div
                            className="Image__base"
                            style={{ backgroundColor: "rgb(255, 255, 255)" }}
                          >
                            <img
                              className="Image__actual"
                              src={
                                "https://icespice.s3.amazonaws.com/img/50832_1611510117.jpg"
                              }
                              alt=""
                            />
                            <div
                              className="Image__loaded Image__actual"
                              style={{
                                backgroundImage: `url("https://icespice.s3.amazonaws.com/img/50832_1611510117.jpg")`,
                                backgroundSize: "cover",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="OrderMetaHolder__productDetails">
                      <div className="OrderMetaHolder__productName">
                        Aldo Black Men Sneakers
                      </div>
                      <div
                        className="OrderMetaHolder__priceLabel"
                        style={{ fontSize: "16px" }}
                      >
                        ₹4199.00
                      </div>
                      <div
                        className="OrderMetaHolder__priceLabel"
                        style={{ color: "lightgray" }}
                      >
                        UK/IND-6 | Black
                      </div>
                      <div className="OrderMetaHolder__priceHolder">
                        <div className="OrderMetaHolder__price" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="OrderCard__deliveryTitleValue"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      paddingRight: "25px",
                    }}
                    onClick={() => {
                      return nav("/itemdetails", { state: "fdk" });
                    }}
                  >
                    <span>
                      <div>
                        <span className="OrderCard__orderNxtbtn" />
                      </div>
                    </span>
                  </div>
                </div>
                <div className="OrderMetaHolder__deliveryMode">
                  <div className="OrderMetaHolder__deliveryModeTitle">
                    Delivery Mode:{" "}
                  </div>
                  <div className="OrderMetaHolder__deliveryModeValue">
                    Home Delivery
                  </div>
                </div>
                <div>
                  <div className="OrderMetaHolder__deliveryMode">
                    <div className="OrderMetaHolder__deliveryModeValue">
                      We have processed the refund request successfully and the
                      amount should reflect in your account in next 3-4 working
                      days
                    </div>
                  </div>
                </div>
                {/* <div className="OrderMetaHolder__sellerMode">
          <div className="OrderMetaHolder__sellerTitle">Sold by:</div>
          <div className="OrderMetaHolder__sellerName">
            Major Brands India Pvt Ltd
          </div>
        </div> */}
              </div>
              <hr />
              <div>
                <div className="OrderMetaHolder__base">
                  <div style={{ width: "100%", display: "flex" }}>
                    <div className="OrderMetaHolder__productImageHolder">
                      <div className="ProductImage__base">
                        <div className="ProductImage__imageHolder">
                          <div
                            className="Image__base"
                            style={{ backgroundColor: "rgb(255, 255, 255)" }}
                          >
                            <img
                              className="Image__actual"
                              src={
                                "https://icespice.s3.amazonaws.com/img/50832_1611510117.jpg"
                              }
                              alt=""
                            />
                            <div
                              className="Image__loaded Image__actual"
                              style={{
                                backgroundImage: `url("https://icespice.s3.amazonaws.com/img/50832_1611510117.jpg")`,
                                backgroundSize: "cover",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="OrderMetaHolder__productDetails">
                      <div className="OrderMetaHolder__productName">
                        Aldo Black Men Sneakers
                      </div>
                      <div
                        className="OrderMetaHolder__priceLabel"
                        style={{ fontSize: "16px" }}
                      >
                        ₹4199.00
                      </div>
                      <div className="OrderMetaHolder__priceLabel">
                        UK/IND-6 | Black
                      </div>
                      <div className="OrderMetaHolder__priceHolder">
                        <div className="OrderMetaHolder__price" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="OrderCard__deliveryTitleValue"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      paddingRight: "25px",
                    }}
                    onClick={() => {
                      return nav("/itemdetails", { state: "fdk" });
                    }}
                  >
                    <span>
                      <div>
                        <span className="OrderCard__orderNxtbtn" />
                      </div>
                    </span>
                  </div>
                </div>
                <div className="OrderMetaHolder__deliveryMode">
                  <div className="OrderMetaHolder__deliveryModeTitle">
                    Delivery Mode:{" "}
                  </div>
                  <div className="OrderMetaHolder__deliveryModeValue">
                    Home Delivery
                  </div>
                </div>
                <div>
                  <div className="OrderMetaHolder__deliveryMode">
                    <div className="OrderMetaHolder__deliveryModeValue">
                      We have processed the refund request successfully and the
                      amount should reflect in your account in next 3-4 working
                      days
                    </div>
                  </div>
                </div>
                {/* <div className="OrderMetaHolder__sellerMode">
          <div className="OrderMetaHolder__sellerTitle">Sold by:</div>
          <div className="OrderMetaHolder__sellerName">
            Major Brands India Pvt Ltd
          </div>
        </div> */}
              </div>
              {/* <div className="OrderDetails__orderStatusVertical">
        <div className="OrderStatusVertical__base">
          <div>Track Order</div>
          <div className="OrderStatusVertical__step">
            <div className="OrderStatusVertical__checkActive OrderStatusVertical__check" />
            <div className="OrderStatusVertical__processNameHolder">
              Return Initiated
              <span>Product will be picked up in 2 business days</span>
            </div>
            <div className="OrderStatusVertical__dateAndTimeHolder">
              <div className="OrderStatusVertical__timeHolder">26 Mar 2023</div>
              <div className="OrderStatusVertical__dateHolder OrderStatusVertical__timeHolder">
                10:32 AM
              </div>
            </div>
          </div>
          <div className="OrderStatusVertical__step">
            <div className="OrderStatusVertical__checkActive OrderStatusVertical__check" />
            <div className="OrderStatusVertical__processNameHolder">
              Refund Initiated
              <span>We have initiated refund request with your bank</span>
            </div>
            <div className="OrderStatusVertical__dateAndTimeHolder">
              <div className="OrderStatusVertical__timeHolder">29 Mar 2023</div>
              <div className="OrderStatusVertical__dateHolder OrderStatusVertical__timeHolder">
                05:35 PM
              </div>
            </div>
          </div>
          <div className="OrderStatusVertical__step">
            <div className="OrderStatusVertical__checkActive OrderStatusVertical__check" />
            <div>Refund Successful</div>
            <div className="OrderStatusVertical__dateAndTimeHolder">
              <div className="OrderStatusVertical__timeHolder">29 Mar 2023</div>
              <div className="OrderStatusVertical__dateHolder OrderStatusVertical__timeHolder">
                08:02 PM
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="OrderDetails__orderStatusVertical">
        <div className="OrderDetails__buttonHolder">
          <div className="OrderDetails__arrowButtonHolder">
            <span className="OrderDetails__lineArrowRight" />
            <div className="OrderDetails__buttonHolderForUpdate">
              <div className="OrderDetails__buttonHolderForUpdate">
                <div className="OrderDetails__replaceHolder">
                  <div className="OrderDetails__review">
                    <div
                      className="UnderLinedButton__base"
                      style={{ color: "rgb(0, 0, 0)" }}
                    >
                      Download Invoice
                      <div
                        className="UnderLinedButton__underline"
                        style={{ backgroundColor: "rgb(0, 0, 0)", height: 0 }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
            </div>
          </div>
          <div className="OrderDetails__base">
            <div className="OrderDetails__payment">
              <div className="OrderViewPaymentDetails__base">
                <div
                  className="OrderViewPaymentDetails__header"
                  style={{
                    borderBottom: "1px solid #ececec",
                    paddingBottom: "10px",
                  }}
                >
                  Payment Details
                </div>
                <div className="OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelText">
                    Sub total
                  </div>
                  <div className="OrderViewPaymentDetails__infoText">
                    ₹13999.00
                  </div>
                </div>
                <div className="OrderViewPaymentDetails__deliverDataHolder OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelText">
                    Delivery &amp; Shipping Charges
                  </div>
                  <div className="OrderViewPaymentDetails__infoText">
                    ₹ 149.00
                  </div>
                </div>
                <div className="OrderViewPaymentDetails__discountDataHolder OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelText">
                    Discount
                  </div>
                  <div className="OrderViewPaymentDetails__infoText">
                    -9800.00
                    <img
                      src={"/assets/images/spicegold.png"}
                      alt=""
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                    />{" "}
                  </div>
                </div>
                <div className="OrderViewPaymentDetails__discountDataHolder OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelText">
                    Coupon
                  </div>
                  <div className="OrderViewPaymentDetails__infoText"> -₹ 0</div>
                </div>
                <div className="OrderViewPaymentDetails__chargeHolder OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelText">
                    Convenience Charges
                  </div>
                  <div className="OrderViewPaymentDetails__infoText">
                    ₹ 0.00
                  </div>
                </div>
                <div className="OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelText">
                    SpiceGold Applied
                  </div>
                  <div className="OrderViewPaymentDetails__infoText">₹0.00</div>
                </div>
                <div className="OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelText">
                    IceGold Applied
                  </div>
                  <div className="OrderViewPaymentDetails__infoText">
                    -₹ 0.0
                  </div>
                </div>
                <div className="OrderViewPaymentDetails__totalHolder OrderViewPaymentDetails__subTotalsHolder">
                  <div className="OrderViewPaymentDetails__labelTextTotal">
                    Total Price
                  </div>
                  <div className="OrderViewPaymentDetails__infoTextTotal">
                    ₹ 4348.00
                  </div>
                </div>
                <hr />
                {/* <div className="OrderViewPaymentDetails__header">
          Payment Mode : <span>UPI</span>
        </div>
        <hr /> */}
                <div
                  className="OrderViewPaymentDetails__header OrderViewPaymentDetails__displayFlex"
                  style={{ marginBottom: "5px", fontSize: "14px" }}
                >
                  Delivery Address:
                  <div className="OrderViewPaymentDetails__marginleft35" />
                </div>
                <div className="OrderViewPaymentDetails__addresstext">
                  <p>
                    Lokesh Katta, Room no - 000, Floor - 0, Building no 0,
                    Mumbai
                  </p>
                  <p>Maharashtra, 400022</p>
                  <p>Ph: 919768479735</p>
                </div>
                <div className="rowGap10" />
                <div
                  className="OrderViewPaymentDetails__orderStatusVertical"
                  onClick={() => {
                    return nav("/faq");
                  }}
                >
                  <div className="OrderViewPaymentDetails__buttonHolder">
                    <div className="OrderViewPaymentDetails__arrowButtonHolder">
                      <span className="OrderViewPaymentDetails__lineArrowRight" />
                      <div>
                        <div>
                          <div className="OrderViewPaymentDetails__replaceHolder">
                            <div className="OrderViewPaymentDetails__review">
                              <div
                                className="UnderLinedButton__base"
                                onClick={() => {
                                  return nav("/faq");
                                }}
                              >
                                Help &amp; Support
                                <div
                                  className="UnderLinedButton__underline"
                                  style={{
                                    backgroundColor: "rgb(0, 0, 0)",
                                    height: 0,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrderDetails;
